/**
 * Photo Gallery Lightbox
 * Supports multiple gallery sections on the same page (scoped by sectionId).
 * - Click a thumbnail to open the lightbox at that image
 * - Prev / Next buttons and left/right arrow keys navigate (wraps around)
 * - Escape key or background click closes
 * - Touch swipe left/right navigates on mobile
 */
(function () {
  var initializedSections = {};

  window.initPhotoGallery = function (sectionId) {
    if (initializedSections[sectionId]) return; // avoid double-binding
    initializedSections[sectionId] = true;

    var grid = document.getElementById('Gallery-' + sectionId);
    var lightbox = document.getElementById('GalleryLightbox-' + sectionId);
    if (!grid || !lightbox) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-gallery-item]'));
    if (!items.length) return;

    var images = items.map(function (item) {
      var img = item.querySelector('img');
      return {
        full: img.getAttribute('data-full') || img.src,
        alt: img.getAttribute('alt') || ''
      };
    });

    var lightboxImage = lightbox.querySelector('[data-gallery-image]');
    var counter = lightbox.querySelector('[data-gallery-counter]');
    var btnClose = lightbox.querySelector('[data-gallery-close]');
    var btnPrev = lightbox.querySelector('[data-gallery-prev]');
    var btnNext = lightbox.querySelector('[data-gallery-next]');

    var currentIndex = 0;

    function render() {
      var data = images[currentIndex];
      lightboxImage.src = data.full;
      lightboxImage.alt = data.alt;
      if (counter) {
        counter.textContent = (currentIndex + 1) + ' / ' + images.length;
      }
    }

    function open(index) {
      currentIndex = index;
      render();
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % images.length;
      render();
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      render();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') showNext();
      if (e.key === 'ArrowLeft') showPrev();
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        open(index);
      });
    });

    btnClose.addEventListener('click', close);
    btnNext.addEventListener('click', showNext);
    btnPrev.addEventListener('click', showPrev);

    // Click on dark background (but not on the image/stage/buttons) closes it
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    // Touch swipe support for mobile
    var touchStartX = 0;
    var touchEndX = 0;
    var SWIPE_THRESHOLD = 40; // px

    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) < SWIPE_THRESHOLD) return;
      if (delta < 0) {
        showNext(); // swiped left -> next
      } else {
        showPrev(); // swiped right -> previous
      }
    }, { passive: true });
  };
})();